<template>
  <div class="inStock column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center">
        <div class="width150">
          <el-select v-model="selectHouse" placeholder="库房名称" style="width: 100%;" filterable clearable>
            <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width150 margin-left10">
          <el-select v-model="selectType" placeholder="入库类型" style="width: 100%;" filterable clearable>
            <el-option v-for="item in typeArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width180 margin-left10">
          <el-input placeholder="入库单号" style="width: 100%;" clearable v-model="orderNum"></el-input>
        </div>
        <div class="width180 margin-left10">
          <el-input placeholder="药品名称" style="width: 100%;" clearable v-model="drugName"></el-input>
        </div>
        <div class="width120 margin-left10">
          <el-select v-model="supplier" placeholder="供应商" style="width: 100%;" filterable clearable>
            <el-option v-for="item in supplierArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width300 margin-left10">
          <el-date-picker type="daterange" range-separator="至" start-placeholder="开始日期"
                          end-placeholder="结束日期" value-format="YYYY-MM-DD" style="width: 100%;" clearable
                          v-model="selectDate">
          </el-date-picker>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          搜索
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">清空</div>
        <div class="btn-blue width140 btn-height40 margin-left40" @click="clickAdd" v-if="canOperate">新建入库单据</div>
        <div class="btn-blank-blue width140 btn-height40 margin-left10" @click="clickImport" v-if="canOperate">
          导入入库单据
        </div>
      </div>
      <div class="row-me row-center margin-top20 font-bold">
        <div>药品总种类：{{ totalDrugCategory }}</div>
        <div class="margin-left50">药品总数量：{{ totalDrugNum }}</div>
      </div>
      <div class="column-me flex1 margin-top20 overflow-auto">
        <div style="height: 88%">
          <el-table ref="tableInStock" :data="tableData" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style" @row-click="clickTableRow" height="100%">
            <el-table-column type="expand">
              <template #default="scope">
                <div class="margin-left15 margin-right15">
                  <el-table :data="scope.row.details.slice((scope.row.pageNo-1)*10,scope.row.pageNo*10)" border
                            header-cell-class-name="table-header-style" cell-class-name="table-cell-style"
                            height="100%">
                    <el-table-column prop="drugName" label="药品名称" align="center"
                                     show-overflow-tooltip width="120"></el-table-column>
                    <el-table-column prop="spec" label="规格" align="center" show-overflow-tooltip
                                     width="120"></el-table-column>
                    <el-table-column prop="unitName" label="单位" align="center" width="120"></el-table-column>
                    <el-table-column prop="batchNo" label="批号" align="center" show-overflow-tooltip
                                     width="150"></el-table-column>
                    <el-table-column prop="validityTime" label="有效期" align="center" width="220"
                                     show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="nums" label="申请数量" align="center" width="120">
                      <template #default="scope">
                        <div class="row-me center-all">
                          <div>{{ scope.row.nums }}</div>
                          <div class="margin-left5">{{ scope.row.unitName }}</div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="costPrice" label="成本价" align="center" width="120"></el-table-column>
                    <el-table-column prop="totalPrice" label="总价" align="center" width="120"></el-table-column>
                    <el-table-column prop="produceTime" label="生产日期" align="center" width="220"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="producerName" label="生厂商" align="center" width="120"></el-table-column>
                    <el-table-column prop="productAddress" label="产地" align="center" width="120"></el-table-column>
                    <el-table-column prop="avaNums" label="库存数量" align="center" width="120"></el-table-column>
                  </el-table>
                  <div class="margin-top10 margin-bottom10 row-me row-center div-pagination">
                    <el-pagination @current-change="e=>handleCurrentChangeItem(e,scope.row)"
                                   :current-page.sync="scope.row.pageNo" layout="total, prev, pager, next, jumper"
                                   :total="scope.row.total">
                    </el-pagination>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="单据编号" align="left" width="200">
              <template v-slot="scope">
                <div class="text-blue">{{ scope.row.batchNo }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="pharmacyName" label="库房名称" align="left" show-overflow-tooltip
                             width="130"></el-table-column>
            <el-table-column prop="typeName" label="类型" align="center" show-overflow-tooltip
                             width="130"></el-table-column>
            <el-table-column prop="totalPrice" label="汇总金额" align="center" show-overflow-tooltip
                             width="130"></el-table-column>
            <el-table-column prop="drugCount" label="品种" align="center" show-overflow-tooltip
                             width="130"></el-table-column>
            <el-table-column prop="storageCount" label="数量" align="center" show-overflow-tooltip
                             width="130"></el-table-column>
            <el-table-column prop="supplierName" label="供应商" align="center" show-overflow-tooltip
                             width="130"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="left" width="220"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="createBy" label="创建人" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateTime" label="执行时间" align="left" width="220"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateBy" label="执行人" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="状态" align="center" width="100" show-overflow-tooltip>
              <template v-slot="scope">
                <div class="text-green" v-if="scope.row.status.value===0">{{ scope.row.status.name }}
                </div>
                <div class="text-green" v-if="scope.row.status.value===1">{{ scope.row.status.name }}
                </div>
                <div class="text-orange" v-if="scope.row.status.value===2">{{ scope.row.status.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" align="center" width="150"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" align="center" width="280" fixed="right" v-if="canOperate">
              <template v-slot="scope">
                <div class="row-me row-center padding-left30">
                  <div class="blue-text margin-right20" @click.stop="clickEdit(scope.row)"
                       v-if="scope.row.status.value!==2 || (scope.row.status.value===2&&scope.row.typeName.indexOf('调拨')===-1&&scope.row.typeName.indexOf('盘盈')===-1
                       &&scope.row.typeName.indexOf('盘亏')===-1)">
                    修改
                  </div>
                  <div class="blue-text margin-right20" v-if="scope.row.status.value===0"
                       @click.stop="clickDone(scope.row)">执行
                  </div>
                  <div class="blue-text margin-right20" v-if="scope.row.status.value===2
                       &&scope.row.typeName.indexOf('调拨')===-1&&scope.row.typeName.indexOf('盘盈')===-1
                       &&scope.row.typeName.indexOf('盘亏')===-1"
                       @click.stop="clickCancelDone(scope.row)">撤销执行
                  </div>
                  <div class="blue-text margin-right20" v-if="scope.row.status.value===0"
                       @click.stop="clickDelete(scope.row)">删除
                  </div>
                  <div class="blue-text" @click.stop="clickExport(scope.row)">导出</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="130" fixed="right" v-else>
              <template v-slot="scope">
                <div class="row-me center-all">
                  <div class="blue-text" @click.stop="clickExport(scope.row)">导出</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="margin-top20">
          <el-pagination background @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>


    <!-- 新增入库单据 -->
    <el-dialog :title="title" v-model="visibleEdit" width="90%"
               :top="selectItem.details&&selectItem.details.length<6?'5vh':'2vh'"
               :destroy-on-close="true" :before-close="beforeClose">
      <div class="dialog-content column-me">
        <div class="row-me row-center grey-div">
          <div>入库人：{{ name }}</div>
          <div class="row-me row-center margin-left70">
            <div><span class="red-star">*</span>库房：</div>
            <div class="width140">
              <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                         v-model="selectItem.pharmacyId" @change="houseChange"
                         :class="{'red-border':showRedBorder&&this.$method.isEmpty(selectItem.pharmacyId)}">
                <el-option v-for="item in houseArray" :key="item.id" :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row-me row-center margin-left30">
            <div><span class="red-star">*</span>入库类型：</div>
            <div class="width140">
              <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                         v-model="selectItem.type"
                         :class="{'red-border':showRedBorder&&this.$method.isEmpty(selectItem.type)}">
                <el-option v-for="item in typeArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row-me row-center margin-left30">
            <div><span class="red-star">*</span>供应商：</div>
            <div class="width140">
              <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                         v-model="selectItem.supplierId"
                         :class="{'red-border':showRedBorder&&this.$method.isEmpty(selectItem.supplierId)}">
                <el-option v-for="item in supplierArray" :key="item.id" :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row-me row-center margin-left30 flex1">
            <div>备注：</div>
            <div class="flex1">
              <el-input placeholder="请输入备注" style="width: 100%;" clearable v-model="selectItem.remark"
                        maxlength="500">
              </el-input>
            </div>
          </div>
        </div>
        <div class="column-me margin-top20" id="drugDiv">
          <div>
            <el-table
                    :data="selectItem.details.slice((selectItem.pageNo-1)*pageSizeEdit,selectItem.pageNo*pageSizeEdit)"
                    border header-cell-class-name="table-header-style" cell-class-name="table-cell-style">
              <el-table-column prop="drugName" label="药品名称" align="center" width="100"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="spec" label="规格" align="center" width="100"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="salePrice" label="销售价" align="center" width="100"
                               show-overflow-tooltip></el-table-column>
              <el-table-column label="单位" align="center" width="120">
                <template #header>
                  <div><span class="red-star">*</span>单位</div>
                </template>
                <template #default="scope">
                  <div class="row-me center-all">
                    <div class="width130">
                      <el-select placeholder="请选择" style="width: 100%;" filterable
                                 v-model="scope.row.unitId">
                        <el-option v-for="item in scope.row.units" :key="item.id"
                                   :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" width="150">
                <template #header>
                  <div><span class="red-star">*</span>批号</div>
                </template>
                <template #default="scope">
                  <div class="row-me center-all">
                    <div class="width100Per" :title="scope.row.batchNo">
                      <el-input placeholder="请输入" style="width: 100%;"
                                v-model="scope.row.batchNo">
                      </el-input>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" width="200">
                <template #header>
                  <div><span class="red-star">*</span>生产日期</div>
                </template>
                <template #default="scope">
                  <div class="row-me center-all">
                    <div class="width180">
                      <el-date-picker type="date" placeholder="选择日期" value-format="YYYY-MM-DD"
                                      style="width: 100%;" v-model="scope.row.produceTime" :clearable="false">
                      </el-date-picker>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" width="100">
                <template #header>
                  <div><span class="red-star">*</span>数量</div>
                </template>
                <template #default="scope">
                  <div class="row-me center-all">
                    <div class="width100" :title="scope.row.nums">
                      <el-input placeholder="请输入" style="width: 100%;"
                                v-model="scope.row.nums" @input="priceChange(1)">
                      </el-input>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" width="100">
                <template #header>
                  <div><span class="red-star">*</span>成本价</div>
                </template>
                <template #default="scope">
                  <div class="row-me center-all">
                    <el-popover ref="popover" placement="bottom" title="" width="200"
                                :content="'最近进价：'+scope.row.newPrice"
                                :visible="scope.row.visible">
                      <template #reference>
                        <div class="width100" :title="scope.row.costPrice">
                          <el-input placeholder="请输入" style="width: 100%;"
                                    v-model="scope.row.costPrice" @input="priceChange(2)"
                                    @focus="scope.row.visible=true" @blur="scope.row.visible=false"
                                    @mouseenter="mouseenterPrice(scope.row)">
                          </el-input>
                        </div>
                      </template>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="总价" align="center" width="120">
                <template #header>
                  <div><span class="red-star">*</span>总价</div>
                </template>
                <template #default="scope">
                  <div class="row-me center-all">
                    <div class="width100" :title="scope.row.totalPrice">
                      <el-input placeholder="请输入" style="width: 100%;"
                                v-model="scope.row.totalPrice" @input="priceChange(3)">
                      </el-input>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" width="200">
                <template #header>
                  <div><span class="red-star">*</span>有效期</div>
                </template>
                <template #default="scope">
                  <div class="row-me center-all">
                    <div class="width180">
                      <el-date-picker type="date" placeholder="选择日期" value-format="YYYY-MM-DD"
                                      style="width: 100%;" v-model="scope.row.validityTime" :clearable="false">
                      </el-date-picker>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="生产商" align="center" width="130">
                <template #default="scope">
                  <div class="row-me center-all">
                    <div class="width130">
                      <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                                 v-model="scope.row.producerId">
                        <el-option v-for="item in producerArray" :key="item.id"
                                   :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="产地" align="center" width="130">
                <template #default="scope">
                  <div class="row-me center-all">
                    <div class="width130">
                      <el-input placeholder="请输入" style="width: 100%;" clearable
                                v-model="scope.row.productAddress">
                      </el-input>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template v-slot="scope">
                  <div class="row-me center-all">
                    <el-popconfirm title="是否要删除本行？" width="250" hide-icon
                                   @confirm="clickDeleteItem(scope.$index)"
                                   v-if="!selectItem.status || (selectItem.status&&selectItem.status.value===0)">
                      <template #reference>
                        <div class="blue-text">
                          删除
                        </div>
                      </template>
                    </el-popconfirm>
                    <div class="blue-text" v-else @click="clickSaveItem(scope.row)">
                      保存
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="margin-top10 margin-bottom10 row-me row-center div-pagination">
          <el-pagination @current-change="handleCurrentChangeEdit" :current-page.sync="selectItem.pageNo"
                         layout="total, prev, pager, next, jumper" :total="selectItem.total"
                         :default-page-size="pageSizeEdit">
          </el-pagination>
        </div>
        <div class="row-me row-center margin-top10 margin-bottom20">
          <el-popover placement="bottom-start" width="600px" trigger="manual" :visible="medicineVisible"
                      v-if="!selectItem.status || (selectItem.status&&selectItem.status.value===0)">
            <div class="overflow-auto" style="max-height: 300px;">
              <el-table :data="drugList" border header-cell-class-name="table-header-style"
                        cell-class-name="table-cell-style" @row-click="clickRow">
                <el-table-column property="name" label="药品名称" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column property="spec" label="规格" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column property="pyName" label="简码" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column property="nums" label="库存" align="center"
                                 show-overflow-tooltip></el-table-column>
              </el-table>
            </div>
            <template #reference>
              <el-input class="width300" placeholder="请输入药品名称或者简码" v-model="medicine" @input="inputChange"
                        @focus="inputChange" @blur="inputBlur">
              </el-input>
            </template>
          </el-popover>
          <div class="flex1"></div>
          <div>
            品种：{{ selectItem.details ? selectItem.details.length : 0 }}&emsp;&emsp;
            数量：{{ getTotalNum }}&emsp;&emsp;
            总价：{{ getTotalPrice }}
          </div>
        </div>
        <div class="line-grey-heng-dashed" v-if="selectItem.logs&&selectItem.logs.length>0"></div>
        <div class="row-me">
          <div class="column-me margin-right30 padding-right20" style="max-height: 500px;overflow:auto;"
               v-if="selectItem.logs&&selectItem.logs.length>0">
            <div v-for="(item,index) in selectItem.logs" :key="index">
              <div class="row-me row-center margin-top20" v-if="showAllLog || (!showAllLog&&index<5)">
                <div class="log-title">{{ item.createTime }}</div>
                <div class="log-title margin-left20">{{ item.operator }}</div>
                <div class="log-title margin-left20">{{ item.remark }}</div>
                <el-tooltip effect="dark" placement="top-start" v-if="!this.$method.isEmpty(item.content)">
                  <template #content>
                    <div style="max-width: 800px;">{{ item.content }}</div>
                  </template>
                  <div class="blue-text margin-left20">详情</div>
                </el-tooltip>
                <div class="blue-text margin-left20" v-if="selectItem.logs.length>4&&!showAllLog&&index===4"
                     @click="showAllLog=true">
                  展开全部
                </div>
                <div class="blue-text margin-left20"
                     v-if="selectItem.logs.length>4&&showAllLog&&index===selectItem.logs.length-1"
                     @click="showAllLog=false">
                  收起部分
                </div>
              </div>
            </div>
          </div>
          <div class="flex1"></div>
          <!--新增或者待执行状态-->
          <div class="row-me row-center flex-end margin-top20"
               v-if="!selectItem.status || (selectItem.status&&selectItem.status.value===0)">
            <div class="btn-blue width120 btn-height40" @click="clickExecute">执行入库</div>
            <div class="btn-blank width120 btn-height40 margin-left10" @click="clickSave">保存草稿</div>
          </div>
          <div class="row-me row-center flex-end margin-top20" v-else>
            <div class="btn-blue width120 btn-height40" @click="clickExport(selectItem)">导出</div>
            <div class="btn-blank width120 btn-height40 margin-left10" @click="clickCancelDone(selectItem)">撤销执行
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 导入入库单据 -->
    <el-dialog title="导入入库单" v-model="visibleImport" width="40%" top="10vh" :destroy-on-close="true">
      <import-in-stock></import-in-stock>
    </el-dialog>


  </div>
</template>

<script>
import ImportInStock from "./importInStock";

export default {
  components: {ImportInStock},
  data() {
    return {
      name: '',
      selectHouse: '',
      selectType: '',
      typeArray: [], //入库类型集合
      selectDate: [],
      orderNum: '',
      drugName: '',
      supplier: '',
      tableData: [],
      pageNo: 1,
      total: 0,
      visibleEdit: false,
      selectItem: {},//选择的对象
      selectItemOld: {},//选择的历史对象，用于关闭弹窗验证提示语
      // 以下弹窗
      houseArray: [], //库房列表
      supplierArray: [], //供应商
      producerArray: [], //生产商
      medicineVisible: false,
      medicine: '',
      drugList: [],//搜索下拉药品
      showRedBorder: false,
      title: '新增入库单据',
      showAllLog: false,//显示全部日志
      totalDrugCategory: 0,//药品总种类
      totalDrugNum: 0,//药品总数量
      visibleImport: false,
      isSaving: false,
      canOperate: false,//是否可操作
      pageSizeEdit: 5,//修改弹窗药品一页数量
    }
  },
  // 计算属性
  computed: {
    getTotalNum() {
      let sum = 0
      for (let item of this.selectItem.details) {
        sum += Number(item.nums)
      }
      return this.$method.toFixed(sum, 0)
    },
    getTotalPrice() {
      let sum = 0
      for (let item of this.selectItem.details) {
        sum += Number(item.totalPrice)
      }
      return this.$method.toFixed(sum, 2)
    },
  },
  // 侦听器
  watch: {},
  // html加载完成之前
  created() {
    let user = JSON.parse(sessionStorage.getItem('user'))
    this.name = user.name
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.getHouseList()
    this.getInStorageType()
    this.getProducer()
    this.getSupplier()
    this.pageNo = 1
    this.getData()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    houseChange(e) {
      this.selectItem.details = []
    },
    clickTableRow(row, index, e) {
      if (this.$method.isEmpty(row.details)) {
        this.bus.$emit('loading', 1)
        this.$getRequest('/admin/stock/detailInStorage', {
          id: row.id
        }).then((res) => {
          if (res) {
            row.details = res.data
            this.$nextTick(() => {
              this.bus.$emit('loading', 0)
              this.$refs.tableInStock.toggleRowExpansion(row)
            })
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        this.$refs.tableInStock.toggleRowExpansion(row)
      }
    },
    //搜索
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    //清空
    clickClear() {
      this.selectHouse = ''
      this.selectType = ''
      this.orderNum = ''
      this.drugName = ''
      this.supplier = ''
      this.selectDate = []
      this.pageNo = 1
      this.getData()
    },
    //新增
    clickAdd() {
      this.title = '新增入库单据'
      this.selectItem = {
        details: [],
        pageNo: 1,
        total: 0,
      }
      this.selectItemOld = this.$method.deepClone(this.selectItem)
      this.medicine = ''
      this.showRedBorder = false
      this.visibleEdit = true
    },
    //编辑
    clickEdit(item) {
      this.title = '修改入库单据'
      for (let row of item.details) {
        row.unitIdOld = row.unitId
        row.batchNoOld = row.batchNo
        row.produceTimeOld = row.produceTime
        row.numsOld = row.nums
        row.costPriceOld = row.costPrice
        row.totalPriceOld = row.totalPrice
        row.validityTimeOld = row.validityTime
        row.producerIdOld = row.producerId
        row.productAddressOld = row.productAddress
      }
      item.pageNo = 1
      item.total = item.details.length
      this.selectItem = this.$method.deepClone(item)
      this.selectItemOld = this.$method.deepClone(this.selectItem)
      this.medicine = ''
      this.showRedBorder = false
      this.visibleEdit = true
    },
    //导入入库单据
    clickImport() {
      this.visibleImport = true
      this.bus.$off('importSuccess')
      this.bus.$on('importSuccess', res => {
        this.visibleImport = false
        setTimeout(() => {
          this.pageNo = 1
          this.getData()
        }, 1000)
      })
    },
    //执行
    clickDone(item) {
      this.$confirm("您确定要执行吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/stock/actionInStorage/' + item.id).then((res) => {
          if (res) {
            this.$message.success(res.message)
            setTimeout(() => {
              this.getData()
            }, 1000)
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //撤销执行
    clickCancelDone(item) {
      this.$confirm("您确定撤销该入库单吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/stock/cancelInStorage/' + item.id).then((res) => {
          if (res) {
            this.$message.success(res.message)
            setTimeout(() => {
              this.pageNo = 1
              this.getData()
            }, 1000)
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //删除
    clickDelete(item) {
      this.$confirm("您确定要删除吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.bus.$emit('loading', 1)
        this.$postRequest('/admin/stock/deleteInStorage', [item.id]).then((res) => {
          if (res) {
            this.bus.$emit('loading', 0)
            this.$message.success(res.message)
            setTimeout(() => {
              this.pageNo = 1
              this.getData()
            }, 1000)
          }
        }).catch((error) => {
          this.bus.$emit('loading', 0)
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //导出
    clickExport(item) {
      let token = sessionStorage.getItem('token')
      let param = {
        id: item.id,
        token: token,
      }
      let url = this.$baseUrl + '/admin/stock/exportInStorage?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    handleCurrentChangeItem(pageNo, item) {
      item.pageNo = pageNo
      setTimeout(() => {
        this.$refs.tableInStock.toggleRowExpansion(item, true)
      }, 100)
    },
    handleCurrentChangeEdit(pageNo) {
      this.selectItem.pageNo = pageNo
      this.selectItemOld.pageNo = pageNo
    },
    //点击药品下拉
    clickRow(row, column, e) {
      this.$getRequest('/admin/stock/getInStorageDetailByDrugId', {
        id: row.id
      }).then((res) => {
        if (res) {
          if (this.contains(this.selectItem.details, res.data)) {
            this.$message.error('不能添加重复药品')
            this.medicine = '' //赋值输入框
          } else {
            this.medicine = '' //赋值输入框
            this.medicineVisible = false //隐藏搜索下拉
            //获取最新进价
            this.$getRequest('/admin/stock/getNewCostPrice', {
              id: row.id
            }).then((res1) => {
              if (res1) {
                res.data.salePrice = row.normalPrice
                res.data.saleUnit = row.saleUnit
                res.data.newPrice = res1.data//最新进价
                res.data.drugName = row.name
                res.data.batchNo = ''
                res.data.produceTime = ''
                res.data.nums = ''
                res.data.costPrice = ''
                res.data.totalPrice = ''
                res.data.validityTime = ''
                res.data.producerId = ''
                res.data.productAddress = ''
                this.selectItem.details.push(res.data) //添加到表格
                this.selectItem.pageNo = Math.ceil(this.selectItem.details.length / this.pageSizeEdit)
                this.selectItemOld.pageNo = Math.ceil(this.selectItem.details.length / this.pageSizeEdit)
                this.selectItem.total += 1
                this.$nextTick(() => {
                  document.getElementById("drugDiv").scrollIntoView({
                    behavior: "instant",
                    block: "end",
                  })
                })
              }
            }).catch((error) => {
              console.log(error)
            })
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取最新进价
    mouseenterPrice(item) {
      this.$getRequest('/admin/stock/getNewCostPrice', {
        id: item.drugId
      }).then((res) => {
        if (res) {
          item.newPrice = res.data//最新进价
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //处方药品输入框失去焦点隐藏药品下拉
    inputBlur() {
      this.medicineVisible = false
    },
    //处方选择药品输入框
    inputChange() {
      //动态搜索药品
      let that = this
      if (this.$method.isEmpty(this.selectItem.pharmacyId)) {
        this.$message.error('请先选择库房')
        this.medicine = ''
        return
      }
      if (this.medicine === '') {
        return
      }
      this.$getRequest('/admin/stock/getPharmacyDrug', {
        pharmacyId: this.selectItem.pharmacyId,
        drugName: this.medicine,
      }).then((res) => {
        if (res) {
          this.drugList = res.data
          this.medicineVisible = this.drugList.length > 0
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    contains(a, obj) {
      for (let i = 0; i < a.length; i++) {
        if (a[i].drugId === obj.drugId) {
          return true;
        }
      }
      return false;
    },
    //删除某一项
    clickDeleteItem(index) {
      this.selectItem.details.splice((this.selectItem.pageNo - 1) * this.pageSizeEdit + index, 1)
      this.selectItem.total -= 1
    },
    //保存某一项
    clickSaveItem(item) {
      if (this.$method.isEmpty(item.unitId)) {
        this.$message.error("单位不能为空")
        return;
      }
      if (this.$method.isEmpty(item.batchNo)) {
        this.$message.error("批号不能为空")
        return;
      }
      if (this.$method.isEmpty(item.produceTime)) {
        this.$message.error("生产日期不能为空")
        return;
      }
      if (this.$method.isEmpty(item.nums)) {
        this.$message.error("数量不能为空")
        return;
      }
      if (this.$method.isEmpty(item.costPrice)) {
        this.$message.error("成本价不能为空")
        return;
      }
      if (this.$method.isEmpty(item.totalPrice)) {
        this.$message.error("总价不能为空")
        return;
      }
      if (this.$method.isEmpty(item.validityTime)) {
        this.$message.error("有效期不能为空")
        return;
      }
      if (!this.$method.isEmpty(item.produceTime) && !this.$method.isEmpty(item.validityTime)) {
        if (new Date(item.produceTime).getTime() > new Date(item.validityTime).getTime()) {
          this.$confirm("生产日期不可晚于有效期，请修改后再保存", "温馨提示", {
            confirmButtonText: "知道了",
            showCancelButton: false,
            type: "warning",
          }).then(() => {
          }).catch(() => {
          });
          return;
        }
      }
      let tipsArray = []//需要提示修改的字段
      if (item.unitIdOld !== item.unitId) {
        tipsArray.push('单位')
      }
      if (item.batchNoOld !== item.batchNo) {
        tipsArray.push('批号')
      }
      if (item.produceTimeOld !== item.produceTime) {
        tipsArray.push('生产日期')
      }
      if (item.numsOld !== item.nums) {
        tipsArray.push('数量')
      }
      if (item.costPriceOld !== item.costPrice) {
        tipsArray.push('成本价')
      }
      if (item.totalPriceOld !== item.totalPrice) {
        tipsArray.push('总价')
      }
      if (item.validityTimeOld !== item.validityTime) {
        tipsArray.push('有效期')
      }
      if (item.producerIdOld !== item.producerId) {
        tipsArray.push('生产商')
      }
      if (item.productAddressOld !== item.productAddress) {
        tipsArray.push('产地')
      }
      //修改字段提示
      if (tipsArray.length > 0) {
        this.$confirm(tipsArray.join('、') + "将会实时生效，是否完成本次修改", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let param = this.$method.deepClone(this.selectItem)
          param.saveType = 2;//v27 1保存 2执行入库
          param.details = [item]
          this.$postRequest('/admin/stock/addInStorage', param).then((res) => {
            if (res) {
              this.$message.success(res.message)
            }
          }).catch((error) => {
            console.log(error)
          })
        }).catch(() => {
        });
      } else {
        this.$message.warning('未修改，无需保存')
      }
    },
    //成本价、数量、总价联动
    priceChange(type) {
      for (let item of this.selectItem.details) {
        if (type === 1) {
          item.nums = this.$method.checkInput(item.nums, 0)
          if (!this.$method.isEmpty(item.nums) && !this.$method.isEmpty(item.costPrice)) {
            item.totalPrice = this.$method.toFixed(item.costPrice * item.nums, 3)
          }
        } else if (type === 2) {
          item.costPrice = this.$method.checkInput(item.costPrice, 3)
          if (!this.$method.isEmpty(item.nums)) {
            item.totalPrice = this.$method.toFixed(item.costPrice * item.nums, 3)
          }
        } else if (type === 3) {
          item.totalPrice = this.$method.checkInput(item.totalPrice, 3)
          if (!this.$method.isEmptyOrZero(item.nums)) {
            item.costPrice = this.$method.toFixed(item.totalPrice / item.nums, 3)
          }
        }
      }
    },
    //关闭弹簧之前
    beforeClose(done) {
      //新建和待执行的才有暂存
      if (this.$method.isEmpty(this.selectItem.id) || this.selectItem.status.value === 0) {
        if (JSON.stringify(this.selectItem) !== JSON.stringify(this.selectItemOld)) {
          this.$confirm("是否需要保存为草稿？", "温馨提示", {
            confirmButtonText: "保存",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
          }).then(() => {
            this.clickSave()
          }).catch(() => {
            done()
          });
        } else {
          done()
        }
      } else {
        done()
      }
    },
    //执行入库
    clickExecute() {
      if (this.isSaving) {
        this.$message.warning('保存中，请稍候')
        return;
      }
      if (this.$method.isEmpty(this.selectItem.pharmacyId) || this.$method.isEmpty(this.selectItem.type)
          || this.$method.isEmpty(this.selectItem.supplierId)) {
        this.showRedBorder = true
        return
      }
      if (this.selectItem.details.length === 0) {
        this.$message.error('请选择药品')
        return
      }
      //检查是否填写完整
      for (var i = 0; i < this.selectItem.details.length; i++) {
        let item = this.selectItem.details[i]
        if (this.$method.isEmpty(item.unitId)) {
          this.$message.error('第' + (i + 1) + '行入库项目没有获取到单位')
          return
        }
        if (this.$method.isEmpty(item.batchNo)) {
          this.$message.error('第' + (i + 1) + '行入库项目没有获取到批号')
          return
        }
        if (this.$method.isEmpty(item.produceTime)) {
          this.$message.error('第' + (i + 1) + '行入库项目没有获取到生产日期')
          return
        }
        if (item.nums === '' || item.nums === null) {
          this.$message.error('第' + (i + 1) + '行入库项目没有获取到数量')
          return
        }
        if (item.unitId === '' || item.unitId === null) {
          this.$message.error('第' + (i + 1) + '行入库项目没有获取到单位')
          return
        }
        if (item.costPrice === '' || item.costPrice === null) {
          this.$message.error('第' + (i + 1) + '行入库项目没有获取到成本价')
          return
        }
        if (item.totalPrice === '' || item.totalPrice === null) {
          this.$message.error('第' + (i + 1) + '行入库项目没有获取到总价')
          return
        }
        if (item.validityTime === '' || item.validityTime === null) {
          this.$message.error('第' + (i + 1) + '行入库项目没有获取到有效期')
          return
        }
        if (item.produceTime && item.produceTime !== '') {
          if (new Date(item.produceTime).getTime() > new Date(item.validityTime)) {
            this.$message.error("名称为【" + item.drugName + "】的数据有效期应该大于生产日期")
            return;
          }
        }
      }
      this.isSaving = true
      this.selectItem.saveType = 2;//v27 1保存 2执行入库
      this.$postRequest('/admin/stock/addInStorage', this.selectItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visibleEdit = false
          setTimeout(() => {
            this.pageNo = 1
            this.getData()
          }, 1000)
        }
        this.isSaving = false
      }).catch((error) => {
        console.log(error)
        this.isSaving = false
      })
    },
    //保存草稿
    clickSave() {
      if (this.isSaving) {
        this.$message.warning('保存中，请稍候')
        return;
      }
      this.isSaving = true
      this.selectItem.saveType = 1;//v27 1保存 2执行入库
      this.$postRequest('/admin/stock/addInStorage', this.selectItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visibleEdit = false
          setTimeout(() => {
            this.pageNo = 1
            this.getData()
          }, 1000)
        }
        this.isSaving = false
      }).catch((error) => {
        console.log(error)
        this.isSaving = false
      })
    },
    //获取库房列表
    getHouseList() {
      this.$getRequest('/admin/pharmacy/listAll', {}).then((res) => {
        if (res) {
          this.houseArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取入库单
    getData() {
      this.bus.$emit('loading', 1)
      this.$getRequest('/admin/stock/pageInStorage', {
        pharmacyId: this.selectHouse,
        type: this.selectType,
        batchNo: this.orderNum,
        drugName: this.drugName,
        supplierId: this.supplier,
        start: this.selectDate[0] ? this.selectDate[0] : '',
        end: this.selectDate[1] ? this.selectDate[1] : '',
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          for (let item of res.data.list) {
            item.pageNo = 1
            item.total = item.details.length
          }
          this.tableData = res.data.list
        }
        this.bus.$emit('loading', 0)
      }).catch((error) => {
        console.log(error)
        this.bus.$emit('loading', 0)
      })
      this.getInStorageTotalCount()
    },
    //获取入库类型
    getInStorageType() {
      this.$getRequest('/admin/dict/getInStorageType', {}).then((res) => {
        if (res) {
          this.typeArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取生产商
    getProducer() {
      this.$getRequest('/admin/supplier/list', {
        producer: true,
      }).then((res) => {
        if (res) {
          this.producerArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取供应商
    getSupplier() {
      this.$getRequest('/admin/supplier/list', {
        supplier: true,
      }).then((res) => {
        if (res) {
          this.supplierArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取药品数量信息
    getInStorageTotalCount() {
      this.$getRequest('/admin/stock/getInStorageTotalCount', {}).then((res) => {
        if (res) {
          this.totalDrugCategory = res.data
          this.totalDrugNum = res.data1
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.inStock {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;
  }

  .dialog-content {

    .grey-div {
      background: #F6F7F9;
      border-radius: 4px;
      padding: 10px 20px;
    }

    .log-title {
      font-size: 18px;
      color: #555F69;
    }
  }

  .div-pagination {
    &:deep(.el-pagination) {
      margin: inherit;
    }
  }
}
</style>
